export default __webpack_public_path__ + "static/media/day-off.78ded1ff.svg";